import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import ColumnItem from 'components/ColumnItem'
import { getInstanceUserSectionSelector } from 'modules/section/selectors'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import ColumnItemImage from 'components/ColumnItem/ColumnItem.Image'

class ProductCommunityPostItem extends React.Component {
  getUrl () {
    return getRelativeUrlReduxUtil(this.props.instance)
  }

  renderImage () {
    const props = {
      image: this.props.instance.data.img,
      url: this.getUrl(),
      hasBorderRadiusBottom: true,
      isSmall: true
    }
    return <ColumnItemImage {...props} />
  }

  render () {
    return (
      <ColumnItem
        isSmall
        style={{
          width: '13.88em'
        }}
      >
        {this.renderImage()}
      </ColumnItem>
    )
  }
}

ProductCommunityPostItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
  instance: PropTypes.object
}

const select = () => createSelector(
  getInstanceUserSectionSelector(),
  (user) => ({
    user
  })
)
export default connect(select)(ProductCommunityPostItem)
